import axios from "axios";
import { SERVER } from "./SERVER";
import { TIMEOUT } from "./TIMEOUT";

class PerDiemService {
    getAllRates(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/perdiem/rates/`, { timeout: TIMEOUT });
    }

    getWeek(token, isoweek) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        const url = `${SERVER}/api/perdiems/${isoweek}`;
        return axios.get(url, {
            timeout: TIMEOUT,
        });
    }
    getAdminWeek(token, isoweek, userId) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        const url = `${SERVER}/api/admin/perdiems/${userId}/${isoweek}`;
        return axios.get(url, {
            timeout: TIMEOUT,
        });
    }

    createPerDiem(data, token, userId) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        const url = `${SERVER}/api/create/perdiem/${userId}`;

        return axios({
            method: "POST",
            url: url,
            data: data,
            timeout: TIMEOUT,
        });
    }

    updatePerDiem(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/perdiem/${id}`, data);
    }

    updatePerDiemRate(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/perdiem/${id}/rate/`, data);
    }

    deletePerDiem(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/perdiem/${id}`);
    }
    approvePerDiem(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/perdiem/${id}/approved/`);
    }
    payPerDiem(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/perdiem/${id}/paid/`);
    }
}

export default new PerDiemService();
